import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, History, User, Play, Search } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  const navItems = [
    { id: 'home', icon: Home, labelKey: 'nav_home', path: '/' },
    { id: 'history', icon: History, labelKey: 'nav_history', path: '/history' },
    { id: 'track', icon: Play, labelKey: '', path: '/track', isMain: true },
    { id: 'jobs', icon: Search, labelKey: 'nav_jobs', path: '/jobs' },
    { id: 'profile', icon: User, labelKey: 'nav_profile', path: '/profile' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-50 safe-area-bottom">
      <div className="max-w-[430px] mx-auto">
        <div className="flex items-center justify-around h-16 px-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            
            if (item.isMain) {
              return (
                <button
                  key={item.id}
                  onClick={() => navigate(item.path)}
                  className="relative -mt-6 flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-orange-500 to-red-600 text-white shadow-lg shadow-orange-500/30 transform transition-all duration-200 hover:scale-105 active:scale-95"
                >
                  <Icon size={24} fill="white" />
                </button>
              );
            }

            return (
              <button
                key={item.id}
                onClick={() => navigate(item.path)}
                className={`flex flex-col items-center justify-center py-2 px-3 transition-all duration-200 ${
                  isActive(item.path)
                    ? 'text-orange-600'
                    : 'text-gray-400 hover:text-gray-600'
                }`}
              >
                <Icon size={22} strokeWidth={isActive(item.path) ? 2.5 : 2} />
                <span className={`text-[10px] mt-1 font-medium ${
                  isActive(item.path) ? 'text-orange-600' : 'text-gray-400'
                }`}>
                  {t(item.labelKey)}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
